import {
    Map,
    View,
    Projection,
    TileLayer,
    VectorLayer,
    XYZ,
    VectorSource,
    Collection,
    Feature,
    Point,
    Icon,
    Style,
    Control,
    MousePosition,
    controlDefaults,
    extent,
    TileGrid,
    Modify,
    createStringXY
} from '../../src/ts/openlayers/ol-bridge';

var settings = {
    width: 16384,
    height: 16384,
    minZoom: 0,
    maxZoom: 6,
    tileSize: 256,
    maxResolution: 16,
    minResolution: 0.25,
    initialZoom: 1,
}

settings.extent = [0, 0, settings.width, settings.height]

settings.resolutions = [64, 32, 16, 8, 4, 2, 1]
settings.tileGrid = new TileGrid({
    extent: settings.extent,
    origin: extent.getTopLeft(settings.extent),
    resolutions: settings.resolutions,
    tileSize: settings.tileSize
})

settings.projection = new Projection({
    code: null,
    units: "pixels",
    extent: settings.extent
});


var NULL_POINT = [null, null]
var DEFAULT_POSITION = settings.height / 2

// Compatibility shim: in edit mode we no longer load the main app bundle,
// so expose the same translator API expected by existing code.
if (typeof geometry__js_translate !== 'function') {
    var geometry__js_translate = function (x, y, p1x, p1y, p2x, p2y, np1x, np1y, np2x, np2y) {
        var oldLeft = Math.min(p1x, p2x)
        var oldRight = Math.max(p1x, p2x)
        var oldBottom = Math.min(p1y, p2y)
        var oldTop = Math.max(p1y, p2y)

        var newLeft = Math.min(np1x, np2x)
        var newRight = Math.max(np1x, np2x)
        var newBottom = Math.min(np1y, np2y)
        var newTop = Math.max(np1y, np2y)

        var oldWidth = oldRight - oldLeft
        var oldHeight = oldTop - oldBottom
        var newWidth = newRight - newLeft
        var newHeight = newTop - newBottom

        // If source anchor is invalid, keep original coordinates.
        if (oldWidth === 0 || oldHeight === 0) {
            return [x, y]
        }

        var scaleX = newWidth / oldWidth
        var scaleY = newHeight / oldHeight

        var newX = newLeft + (scaleX * (x - oldLeft))
        var newY = newBottom + (scaleY * (y - oldBottom))
        return [newX, newY]
    }
}

// get parameters from the query string and set them in the model
cmsEditStartXCoord(getParameterByName("xCoord", DEFAULT_POSITION))
cmsEditStartYCoord(getParameterByName("yCoord", DEFAULT_POSITION))
if ((cmsEditStartXCoord() == 8000 && cmsEditStartYCoord() == 8000)  || 
    (cmsEditStartXCoord() == 5000 && cmsEditStartYCoord() == 5000)){
    cmsEditStartXCoord(0);
    cmsEditStartYCoord(0);
}
cmsEditP1Coord(getParameterByName("p1Coord", NULL_POINT))
cmsEditP2Coord(getParameterByName("p2Coord", NULL_POINT))
cmsEditIdFeature(getParameterByName("idFeature", "UNDEFINED_ID_FEATURE"))
cmsEditFloorplanApiGateway(getParameterByName("floorplan_api_gateway", ""))
cmsEditIdLocation(getParameterByName("idLocation", "UNDEFINED_ID_LOCATION"))
cmsEditIcon(getParameterByName("icon", "UNDEFINED_ICON"))
cmsEditIdDrawing(getParameterByName("drawingid", "UNDEFINED_ICON"))

if (cmsEditFloorplanApiGateway() == ""){
    alert("Error: Missing 'floorplan_api_gateway' parameter. Defaulting to https://floorplanapi.facsur.com. " + feature + ".")
    cmsEditFloorplanApiGateway("https://floorplanapi.facsur.com")
}
if (cmsEditIdDrawing() == ""){
    var feature = "asset"
    if (endpoint_workorder == true){
        feature = "workorder"
    }
    if (endpoint_attachment == true){
        feature = "attachment"
    }
    if (endpoint_location == true){
        feature = "location"
    }    
    alert("Error: There is no floor associated with this " + feature + ". Cannot perform the edit for this drawing without a floor.")
}
cmsEditApiGateway(getParameterByName("api_gateway", "UNDEFINED_API_GATEWAY"))
cmsEditCustomerName(getParameterByName("customername", "UNDEFINED_CUSTOMERNAME"))
cmsEditSegmentId(getParameterByName("segmentid", "UNDEFINED_SEGMENTID"))
cmsEditToken(getParameterByName("token", "UNDEFINED_TOKEN"))
cmsEditStorageAccountUrl(getParameterByName("storage_account_url", "UNDEFINED_STORAGE_ACCOUNT_URL"))


//
// fix the p1 and p2 to match this drawing.
// scenarios (see flow_edit_p1p2 in /docs):
// if p2/p2 are not null:
//    if drawing p1/p2 are not null:
//        translate position
//        p1/p2 = drawing p1/p2
//    if drawing p1/p2 are null:
//        do nothing
// if p2/p2 are null:
//        p1/p2 = drawing p1/p2
//        do notihn to the position

function pointIsValid(p) {
    return (p[0] != null) && (p[1] != null)
}

function anchorIsValid(p1p2) {
    const p1 = p1p2[0]
    const p2 = p1p2[1]

    // there are two ways an anchor is invalid:
    // p1 == p2
    if (p1[0] == p2[0]) {
        if (p1[1] == p2[1]) {
            return false
        }
    }

    // p1 or p2 contains a null
    return pointIsValid(p1) && pointIsValid(p2)
}

var _webapp_globals = {}

_webapp_globals.features = new Collection();

function initialize_the_map() {
    let feature_p1p2 = cmsEditFeatureP1P2()
    let drawing_p1p2 = cmsEditDrawingP1P2()
    let old_coords = cmsEditCoords()
    let new_coords = null

    if (!anchorIsValid(drawing_p1p2)) {
        // if the drawing has no p1/p2, DO NOT PROCEED.
        console.error("There is no P1/P2 for this drawing: " + cmsEditIdDrawing() + ". Cannot perform the edit for this drawing.")
        alert("There is no P1/P2 for this drawing: " + cmsEditIdDrawing() + ". Cannot perform the edit for this drawing.")
        new_coords = null
        cmsEditCoords(new_coords)
    }

    if (!anchorIsValid(feature_p1p2)) {
        // if the feature has no p1p2, inherit the drawing p1p2
        cmsEditFeatureP1P2(drawing_p1p2)
        console.log("There is no P1/P2 for this feature: " + cmsEditIdFeature())
    }
    else {
        // translate the postion
        new_coords = geometry__js_translate(
            old_coords[0],
            old_coords[1],
            feature_p1p2[0][0],
            feature_p1p2[0][1],
            feature_p1p2[1][0],
            feature_p1p2[1][1],
            drawing_p1p2[0][0],
            drawing_p1p2[0][1],
            drawing_p1p2[1][0],
            drawing_p1p2[1][1]);

        // update the start position
        if (cmsEditStartXCoord() == 0 && cmsEditStartYCoord() == 0){
            new_coords = [0,0]
        }
        
        cmsEditStartXCoord(new_coords[0])
        cmsEditStartYCoord(new_coords[1])
        cmsEditCoords(new_coords)
        console.info("updated the position from " + old_coords + " to " + new_coords);
    }
    // The p1/p2 for this point is now the p1/p2 for this drawing
    // Even though this may mean that the p1/p2 are set to null.
    // it is up to the database to ensure there are valid P1/P2 values for all the
    // drawings in the database.
    cmsEditFeatureP1P2(drawing_p1p2)
    var FEATURE_TYPE_ASSET = "asset"
    var FEATURE_TYPE_ATTACHMENT = "attachment"
    var FEATURE_TYPE_FINDING = "finding"
    var FEATURE_TYPE_WORKORDER = "workorder"
    var FEATURE_TYPE_LOCATION = 'location'

    if (endpoint_asset) {
        cmsEditFeatureType(FEATURE_TYPE_ASSET)
    }

    if (endpoint_attachment) {
        cmsEditFeatureType(FEATURE_TYPE_ATTACHMENT)
    }

    if (endpoint_finding) {
        cmsEditFeatureType(FEATURE_TYPE_FINDING)
    }
    if (endpoint_workorder) {
        cmsEditFeatureType(FEATURE_TYPE_WORKORDER)
    }
    if (endpoint_location) {
        cmsEditFeatureType(FEATURE_TYPE_LOCATION)
    }

    _webapp_globals.features.push(createCmsFeature(cmsEditIcon(), cmsEditIdFeature(), cmsEditStartXCoord(), cmsEditStartYCoord()))
}



// setup listener to receive messages from the parent iframe. Update idLocation is the only supported message at this time.
window.addEventListener('message', function (event) {
    if (event.data.msg_type === undefined) {
        console.error("missing 'msg_type' value")
        return
    }
    if (event.data.msg_type == "MAP_RESIZE") {
        if (map !== undefined) {
            map.updateSize();
        }
        return
    }
    if (event.data.msg_type == "CHANGE_IDLOCATION") {
        const idLocation = event.data.idLocation
        if (idLocation === undefined) {
            console.error("change idLocation missing idLocation value")
            return
        }
        setFloorplan(idLocation);
    }

}, false);


function undoCustomControl(opt_options) {

    var options = opt_options || {};

    var button = document.createElement('button');
    var span = document.createElement('span');
    span.setAttribute("class", 'glyphicon glyphicon-share')
    button.appendChild(span)
    var this_ = this;
    var onClick = function (e) {
        cmsEditCoords([cmsEditStartXCoord(), cmsEditStartYCoord()])
        notifyParentOfChange()
        _webapp_globals.features.removeAt(0)
        _webapp_globals.features.push(createCmsFeature(cmsEditIcon(), cmsEditIdFeature(), cmsEditXCoord(), cmsEditYCoord()))
    };
    var onTouchStart = function (e) {
        console.log("A Touchstart!!")
        onClick(e)
    };

    button.addEventListener('click', onClick, false);
    button.addEventListener('touchstart', onTouchStart, false);

    var element = document.createElement('div');
    element.className = ' ol-unselectable ol-control reset-control';
    element.appendChild(button);

    return new Control({
        element: element,
        target: options.target
    });
};


var view = new View({
    center: extent.getCenter(settings.extent),
    zoom: settings.initialZoom,
    projection: settings.projection,
    minZoom: settings.minZoom,
    maxZoom: settings.maxZoom,
    resolutions: settings.resolutions,
    constrainResolution: true,
    extent: settings.extent,
    constrainOnlyCenter: true
})


function setFloorplan(idLocation) {
    cmsEditIdLocation(idLocation)
    if (map === undefined) {
        return;
    }
    map.removeLayer(floorplan_layer)
    floorplan_layer = new TileLayer({
        isBaseLayer: true,
        source: new XYZ({
            url: cmsEditTilesUrl(),
            wrapX: false,
            noWrap: true,
            tileSize: settings.tileSize,
            tileGrid: settings.tileGrid,
            maxZoom: settings.maxZoom,
            //       crossOrigin: true,
            projection: settings.projection,
        })
    });

    map.addLayer(floorplan_layer)
    map.updateSize();
}


var floorplan_layer = new TileLayer({
    isBaseLayer: true,
    source: new XYZ({
        url: cmsEditTilesUrl(),

        wrapX: false,
        noWrap: true,
        tileSize: settings.tileSize,
        tileGrid: settings.tileGrid,
        maxZoom: settings.maxZoom,
        //       crossOrigin: true,
        projection: settings.projection,
    })
});


var mousePositionControl = new MousePosition({
    coordinateFormat: createStringXY(4),
    // comment the following two lines to have the mouse position
    // be placed within the map.
    //    className: 'custom-mouse-position',
    //    target: document.getElementById('mouse-position'),
    undefinedHTML: '&nbsp;'
});


function createFeature(x, y) {
    const pt = new Point([x, y], "XY")
    const feature = new Feature({ geometry: pt })
    return feature
}


function createCmsFeature(icon, id, xCoord, yCoord) {
    const iconImg = new Icon(({
        anchor: [.5, .5],
        anchorXUnits: 'fraction',
        anchorYUnits: 'fraction',
        src: icon
    }))

    const iconStyle = new Style(
        {
            image: iconImg
        }
    )

    const feature = createFeature(xCoord, yCoord)
    feature.setId(id)  // the id of the feature is assumed to be stable and unique
    feature.setStyle(iconStyle)
    console.log(feature)

    return feature
}


var map = new Map({
    controls: controlDefaults({
        attributionOptions: /** @type {olx.control.AttributionOptions} */ ({
            collapsible: false
        })
    }).extend([
        mousePositionControl,
        new undoCustomControl(),
    ]),
    layers: [floorplan_layer],
    target: 'map',
    view: view,
    renderer: "canvas",
    ol3Logo: false,
    projection: settings.projection,
    extent: settings.projection.getExtent()

});

function refreshMapSize() {
    map.updateSize();
}

// In modal/tab scenarios the iframe can start hidden; refresh several times
// and on future size changes so OL recalculates canvas dimensions.
setTimeout(refreshMapSize, 0);
setTimeout(refreshMapSize, 200);
setTimeout(refreshMapSize, 800);
window.addEventListener('resize', refreshMapSize);

var mapElement = document.getElementById('map');
if (mapElement && typeof ResizeObserver !== 'undefined') {
    var mapResizeObserver = new ResizeObserver(function () {
        refreshMapSize();
    });
    mapResizeObserver.observe(mapElement);
}


var editable_asset_layer = new VectorLayer({

    source: new VectorSource({
        features: _webapp_globals.features,
        wrapX: false,
        noWrap: true,

        projection: settings.projection,
        minResolution: settings.minResolution,
        maxResolution: settings.maxResolution,
    })
});
editable_asset_layer.setMap(map);

var modify = new Modify({
    features: _webapp_globals.features,
});



function notifyParentOfChange() {
    const force_value = function (coord) {
        if (!pointIsValid(coord)) {
            coord = [0, 0]
        }
        return coord
    }
    const msg = {
        coords: cmsEditCoords(),
        p1Coord: force_value(cmsEditP1Coord()),
        p2Coord: force_value(cmsEditP2Coord()),
        feature_type: cmsEditFeatureType(),
        msg_type: "FEATURE_LOCATION_UPDATED",
        id: cmsEditIdFeature(),
        idLocation: cmsEditIdLocation()
    }
    console.log("sending message to parent iframe")
    jsonLog(msg)
    parent.postMessage(msg, "*")  // awh TODO: make this a real path
}


modify.on("modifyend", function (x) {
    //console.log("modifyend!")
    const coords = _webapp_globals.features.getArray()[0].getGeometry().getCoordinates()
    cmsEditCoords(coords)
    notifyParentOfChange()

})

map.addInteraction(modify);

// TilesURL or p1/p2 should not be sent from tech anymore. 
getDrawingInfo(cmsEditIdDrawing(), cmsEditFloorplanApiGateway(),  function (tiles_url, p1, p2) {
    cmsEditTilesUrl(tiles_url);
    cmsEditDrawingP1Coord(p1);
    cmsEditDrawingP2Coord(p2);
    setFloorplan(cmsEditIdLocation())
    initialize_the_map();
})


// WEBPACK FOOTER //
// ./edit/js/cms_view_edit_view.js